import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import ActionLogsPage from "@pages/ActionLogsPage";
import BuildingPage from "@pages/BuildingPage";
import CampaignBlocksPage from "@pages/CampaignBlocksPage";
import CampaignBlocksPageV2 from "@pages/CampaignBlocksPageV2";
import CampaignListPage from "@pages/CampaignListPage";
import CampaignPreviewPage from "@pages/CampaignPreviewPage";
import CampaignViewPage from "@pages/CampaignViewPage";
import CustomerPage from "@pages/CustomerPage";
import DashboardPage from "@pages/DashboardPage";
import DemoPage from "@pages/DemoPage";
import DeviceGroupListPage from "@pages/DeviceGroupListPage";
import DeviceGroupViewPage from "@pages/DeviceGroupViewPage";
import DeviceListPage from "@pages/DeviceListPage";
import DevicePredictionPage from "@pages/DevicePredictionPage";
import DeviceViewPage from "@pages/DeviceViewPage";
import FloorPage from "@pages/FloorPage";
import ImportantBlocksPageV2 from "@pages/ImportantBlocksPageV2";
import ImportantListPage from "@pages/ImportantListPage";
import ImportantManagePreviewPage from "@pages/ImportantManagePreviewPage";
import ImportantPreviewPage from "@pages/ImportantPreviewPage";
import ImportantViewPage from "@pages/ImportantViewPage";
import KiosViewPage from "@pages/KiosViewPage";
import LocationPage from "@pages/LocationPage";
import LoginPage from "@pages/LoginPage";
import MediaListPage from "@pages/MediaListPage";
import MediaLogPage from "@pages/MediaLogPage";
import MediaViewPage from "@pages/MediaViewPage";
import NoAccessPage from "@pages/NoAccessPage";
import PredictionPage from "@pages/PredictionPage";
import PreviewPage from "@pages/PreviewPage";
import RolePage from "@pages/RolePage";
import ScreenShotPage from "@pages/ScreenShotPage";
import TestPage from "@pages/TestPage.js";
import TestPage10 from "@pages/TestPage10";
import TestPage11 from "@pages/TestPage11";
import TestPage2 from "@pages/TestPage2";
import TestPage3 from "@pages/TestPage3";
import TestPage4 from "@pages/TestPage4";
import TestPage5 from "@pages/TestPage5";
import TestPage6 from "@pages/TestPage6";
import TestPage7 from "@pages/TestPage7";
import TestPage8 from "@pages/TestPage8";
import TestPage9 from "@pages/TestPage9";
import TestUploadMultipleFilePage from "@pages/TestUploadMultipleFilePage";
import UserPage from "@pages/UserPage";
import { PublicRoute } from "@routes/public";
import {
  KEY_CAMPAIGNS,
  KEY_CAMPAIGNS_ADD,
  KEY_DASHBOARD,
  KEY_DEVICE_MANAGEMENT_BUILDINGS,
  KEY_DEVICE_MANAGEMENT_CUSTOMERS,
  KEY_DEVICE_MANAGEMENT_DEVICES,
  KEY_DEVICE_MANAGEMENT_DEVICE_GROUPS,
  KEY_DEVICE_MANAGEMENT_FLOORS,
  KEY_DEVICE_MANAGEMENT_PROJECT,
  KEY_IMPORTANT,
  KEY_MEDIAS,
  KEY_REPORTS_ACTION_LOGS,
  KEY_REPORTS_MEDIA_LOGS,
  KEY_REPORTS_SCREENSHOT,
  KEY_USERS_MANAGEMENTS_ROLES,
  KEY_USERS_MANAGEMENTS_USERS,
} from "@static/PERMISSION_KEY";

import { PrivateRoute } from "./private";
// import ExamplePage from "@pages/ExamplePage";
// import HomePage from "@pages/HomePage";
// import { PrivateRoute } from "@routes/private";

export default () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* <Route path="/test" element={<TestPage />} />
        <Route path="/test2" element={<TestPage2 />} />
        <Route path="/test3" element={<TestPage3 />} />
        <Route path="/demo" element={<DemoPage />} />
        */}
        {/* <Route path="/test4" element={<TestPage4 />} /> */}
        {/* <Route path="/test" element={<TestPage />} />
        <Route path="/test5" element={<TestPage5 />} />
        <Route path="/test6" element={<TestPage6 />} />
        <Route path="/test7" element={<TestPage7 />} />
        <Route path="/test8" element={<TestPage8 />} /> */}
        <Route path="/test11" element={<TestPage11 />} />
        <Route path="/test10" element={<TestPage10 />} />

        <Route
          path="/test-upload-multiple"
          element={<TestUploadMultipleFilePage />}
        />

        <Route path="/preview-campaign/:id" element={<PreviewPage />} />
        <Route
          path="/"
          element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute permission={KEY_DASHBOARD}>
              <DashboardPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/action-logs"
          element={
            <PrivateRoute permission={KEY_REPORTS_ACTION_LOGS}>
              <ActionLogsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/media-logs"
          element={
            <PrivateRoute permission={KEY_REPORTS_MEDIA_LOGS}>
              <MediaLogPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/screenshot"
          element={
            <PrivateRoute permission={KEY_REPORTS_SCREENSHOT}>
              <ScreenShotPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/roles"
          element={
            <PrivateRoute permission={KEY_USERS_MANAGEMENTS_ROLES}>
              <RolePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/users"
          element={
            <PrivateRoute permission={KEY_USERS_MANAGEMENTS_USERS}>
              <UserPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/customers"
          element={
            <PrivateRoute permission={KEY_DEVICE_MANAGEMENT_CUSTOMERS}>
              <CustomerPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/floors"
          element={
            <PrivateRoute permission={KEY_DEVICE_MANAGEMENT_FLOORS}>
              <FloorPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/medias"
          element={
            <PrivateRoute permission={KEY_MEDIAS}>
              <MediaViewPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/medias-list"
          element={
            <PrivateRoute permission={KEY_MEDIAS}>
              <MediaListPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/projects"
          element={
            <PrivateRoute permission={KEY_DEVICE_MANAGEMENT_PROJECT}>
              <LocationPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/buildings"
          element={
            <PrivateRoute permission={KEY_DEVICE_MANAGEMENT_BUILDINGS}>
              <BuildingPage />
            </PrivateRoute>
          }
        />

        {/* =========== IMPORTANT =========== */}

        <Route path="/important" element={<ImportantViewPage />} />

        <Route path="/important-list" element={<ImportantListPage />} />

        <Route path="/important-blocks" element={<ImportantBlocksPageV2 />} />
        <Route
          path="/important-preview-campaign/:id"
          element={<ImportantPreviewPage />}
        />

        <Route path="/prediction/:playerId" element={<PredictionPage />} />

        <Route
          path="/important-manage-preview-campaign"
          element={<ImportantManagePreviewPage />}
        />

        {/* important-preview-campaign */}
        {/* =========== IMPORTANT =========== */}

        <Route
          path="/campaigns"
          element={
            <PrivateRoute permission={KEY_CAMPAIGNS}>
              <CampaignViewPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/campaigns-list"
          element={
            <PrivateRoute permission={KEY_CAMPAIGNS}>
              <CampaignListPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/campaign-preview"
          element={
            <PrivateRoute permission={KEY_CAMPAIGNS}>
              <CampaignPreviewPage />
            </PrivateRoute>
          }
        />
        {/* <Route
          path="/campaign-blocks-v1"
          element={
            <PrivateRoute permission={KEY_CAMPAIGNS_ADD}>
              <CampaignBlocksPage />
            </PrivateRoute>
          }
        /> */}
        <Route
          path="/campaign-blocks"
          element={
            <PrivateRoute permission={KEY_CAMPAIGNS_ADD}>
              <CampaignBlocksPageV2 />
            </PrivateRoute>
          }
        />
        <Route
          path="/devices"
          element={
            <PrivateRoute permission={KEY_DEVICE_MANAGEMENT_DEVICES}>
              <DeviceViewPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/devices-list"
          element={
            <PrivateRoute permission={KEY_DEVICE_MANAGEMENT_DEVICES}>
              <DeviceListPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/devices-prediction"
          element={
            <PrivateRoute permission={KEY_DEVICE_MANAGEMENT_DEVICES}>
              <DevicePredictionPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/device-groups"
          element={
            <PrivateRoute permission={KEY_DEVICE_MANAGEMENT_DEVICE_GROUPS}>
              <DeviceGroupViewPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/device-groups-list"
          element={
            <PrivateRoute permission={KEY_DEVICE_MANAGEMENT_DEVICE_GROUPS}>
              <DeviceGroupListPage />
            </PrivateRoute>
          }
        />

        <Route path="/kios-view/:id" element={<KiosViewPage />} />

        <Route path="/no-access" element={<NoAccessPage />} />
      </Routes>
    </BrowserRouter>
  );
};
